import {
  IMPRESSIONS,
  OTS_SGM_MNG_ACTIVE_IDS,
  OTS_SGM_MNG_CPM,
  OTS_SGM_MNG_EFFECTIVE_CPM,
  OTS_SGM_MNG_LAST_UPDATED,
  OTS_SGM_MNG_POM,
  OTS_SGM_MNG_RECEIVED_IDS,
  OTS_SGM_MNG_REVENUE,
} from '../../content';
import {
  OTS_SEGMENT_MANAGER_COLUMN_KEYS,
  OTS_SEGMENT_MANAGER_DEFAULT_PLATFORM,
} from '../../constants';

export const PLATFORM_OPTIONS = [
  {
    label: OTS_SEGMENT_MANAGER_DEFAULT_PLATFORM,
    value: OTS_SEGMENT_MANAGER_DEFAULT_PLATFORM,
  },
];

/**
 * Get TTD platform column configuration with sort state
 * @param sortBy - Current sort column
 * @param sortOrder - Current sort order ('ASC' | 'DESC')
 * @returns Array of column configurations with sort state
 */
export const getTtdColumns = (sortBy: string, sortOrder: 'ASC' | 'DESC') => [
  {
    title: OTS_SGM_MNG_RECEIVED_IDS,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.RECEIVED_IDS,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.RECEIVED_IDS,
    sortOrder:
      sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.RECEIVED_IDS
        ? sortOrder
        : undefined,
  },
  {
    title: OTS_SGM_MNG_ACTIVE_IDS,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.ACTIVE_IDS,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.ACTIVE_IDS,
    sortOrder:
      sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.ACTIVE_IDS
        ? sortOrder
        : undefined,
  },
  {
    title: OTS_SGM_MNG_CPM,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.CPM,
    width: '9%',
    rightAlign: true,
    isSorted: sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.CPM,
    sortOrder:
      sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.CPM ? sortOrder : undefined,
  },
  {
    title: OTS_SGM_MNG_POM,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.POM,
    width: '7%',
    rightAlign: true,
    isSorted: sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.POM,
    sortOrder:
      sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.POM ? sortOrder : undefined,
  },
  {
    title: IMPRESSIONS,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.IMPRESSIONS,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.IMPRESSIONS,
    sortOrder:
      sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.IMPRESSIONS
        ? sortOrder
        : undefined,
  },
  {
    title: OTS_SGM_MNG_EFFECTIVE_CPM,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.EFFECTIVE_CPM,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.EFFECTIVE_CPM,
    sortOrder:
      sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.EFFECTIVE_CPM
        ? sortOrder
        : undefined,
  },
  {
    title: OTS_SGM_MNG_REVENUE,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.REVENUE,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.REVENUE,
    sortOrder:
      sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.REVENUE
        ? sortOrder
        : undefined,
  },
  {
    title: OTS_SGM_MNG_LAST_UPDATED,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.LAST_UPDATED_AT,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.LAST_UPDATED_AT,
    sortOrder:
      sortBy === OTS_SEGMENT_MANAGER_COLUMN_KEYS.LAST_UPDATED_AT
        ? sortOrder
        : undefined,
  },
];
